export interface BatchStatisticsYearlyOutputRequest {
  outputYear: string
  outputType: string
  batchType: string
}

export function BatchStatisticsYearlyOutputRequestToJSON(
  value: BatchStatisticsYearlyOutputRequest
): any {
  return {
    output_year: value.outputYear,
    output_type: value.outputType,
    batch_type: value.batchType
  }
}
